import React from 'react';
import './Header.css';

function Header({length}) {
    return (
        <div className="Header">
            <h1 className="header__heading">Coursie</h1>
        </div>
    )
}

export default Header
